// extracted by mini-css-extract-plugin
export var active = "s_bd";
export var arrow = "s_9";
export var icon = "s_bq";
export var link = "s_bx";
export var links = "s_bX";
export var scrolled = "s_z";